import { HeroBannerContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/HeroBannerLayout/components/HeroBannerContent"
import { HeroBannerLayoutProps } from "@/types/types"
import { ComponentConfig } from "@measured/puck"
import { generateResponsiveCSS } from "../../../lib/helper"

export const RenderConfig: ComponentConfig<HeroBannerLayoutProps> = {
  render: ({
    slides,
    swiperConfig,
    background,
    backgroundImage, // Legacy support
    topText,
    mainText,
    mainTextStyles,
    listButtons,
    buttonStyles,
    className,
    styles,
    responsiveType,
    // Legacy props
    mainTextFontSize,
    mainTextFontWeight,
    mainTextLineHeight,
    backgroundHeight,
    buttonSize,
    buttonFontSize,
    buttonFontWeight,
    buttonLineHeight,
    buttonGap,
  }) => {
    const id = `hero-banner-layout-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType || "desktopFirst")

    return (
      <>
        {responsiveCSS}
        <HeroBannerContent
          id={id}
          slides={slides}
          swiperConfig={swiperConfig}
          background={background}
          backgroundImage={backgroundImage}
          topText={topText}
          mainText={mainText}
          mainTextStyles={mainTextStyles}
          listButtons={listButtons}
          buttonStyles={buttonStyles}
          className={className}
          mainTextFontSize={mainTextFontSize}
          mainTextFontWeight={mainTextFontWeight}
          mainTextLineHeight={mainTextLineHeight}
          backgroundHeight={backgroundHeight}
          buttonSize={buttonSize}
          buttonFontSize={buttonFontSize}
          buttonFontWeight={buttonFontWeight}
          buttonLineHeight={buttonLineHeight}
          buttonGap={buttonGap}
        />
      </>
    )
  },
}
